<template>
  <el-dialog
    v-model="visible"
    title="Управление ролями"
    width="800px"
  >
    <el-button type="primary" @click="openRoleForm(null)">Добавить должность</el-button>

    <el-table :data="roles" border style="margin-top: 20px">
      <el-table-column prop="name" label="Название" />
      <el-table-column label="Права">
        <template #default="scope">
          <div v-if="scope.row.permissions.length === 1 && scope.row.permissions[0] === '*'">
            <el-tag type="success" size="small" style="margin: 2px">все</el-tag>
          </div>
          <div v-else>
            <div class="perm-tags-row">
              <el-tag
                v-for="perm in scope.row.permissions.slice(0, 4)"
                :key="perm"
                type="info"
                size="small"
                style="margin: 2px"
              >
                {{ permissionLabels[perm] || perm }}
              </el-tag>
              <el-popover
                v-if="scope.row.permissions.length > 4"
                placement="top"
                width="300"
                trigger="click"
              >
                <div style="max-height:200px;overflow-y:auto;">
                  <el-tag
                    v-for="perm in scope.row.permissions"
                    :key="perm"
                    type="info"
                    size="small"
                    style="margin: 2px"
                  >
                    {{ permissionLabels[perm] || perm }}
                  </el-tag>
                </div>
                <template #reference>
                  <el-tag
                    type="warning"
                    size="small"
                    style="margin: 2px; cursor: pointer"
                  >
                    + ещё {{ scope.row.permissions.length - 4 }}
                  </el-tag>
                </template>
              </el-popover>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Действия" width="150">
        <template #default="scope">
          <template v-if="isAdminRole(scope.row)">
            <span style="color: var(--ui-color-text-secondary);">—</span>
          </template>
          <template v-else>
            <el-button size="small" @click="openRoleForm(scope.row)">Ред.</el-button>
            <el-button size="small" type="danger" @click="deleteRole(scope.row)">Удл.</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <RoleFormDialog
      v-model="showForm"
      :role="currentRole"
      :permission-labels="permissionLabels"
      :permission-groups="permissionGroups"
      @submit="handleRoleSubmit"
    />
  </el-dialog>
</template>

<script>

import RoleFormDialog from '@/components/views/modal/RoleFormDialog.vue'
import { mapGetters } from 'vuex'
import { permissionGroups, permissionLabels } from '@/components/util/accessHelper'

export default {
  components: { RoleFormDialog },
  props: {
    modelValue: Boolean,
    employees: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      visible: this.modelValue,
      showForm: false,
      currentRole: null,
      permissionLabels,
      permissionGroups,
    }
  },
  computed: {
    ...mapGetters('roles', { rolesFromStore: 'roles' }),
    roles() {
      return this.rolesFromStore
    }
  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('update:modelValue', val)
    }
  },
  methods: {
    openRoleForm(role) {
      this.currentRole = role || {
        name: '',
        permissions: []
      }
      this.showForm = true
    },
    async deleteRole(node) {
      if (this.employees.some(emp => emp.role?.id === node.id || emp.role_id === node.id)) {
        this.$message.error('Невозможно удалить: должность используется сотрудником')
        return
      }
      const message = `Вы уверены, что хотите удалить должность "${node.name}"?`
      this.$confirm(message, 'Внимание', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('roles/deleteRole', node.id);
      }).catch(() => {
        this.$message({ type: 'info', message: 'Удаление отменено' })
      })
    },
    async handleRoleSubmit(roleData) {
      try {
        if (roleData.id) {
          await this.$store.dispatch('roles/updateRole', roleData)
        } else {
          await this.$store.dispatch('roles/createRole', roleData)
        }
        await this.$store.dispatch('roles/fetchRoles')
      } catch (error) {
        console.error('Ошибка сохранения роли:', error)
      }
      this.showForm = false
    },
    isAdminRole(role) {
      if (typeof role.permissions === 'string' && role.permissions === '*') return true
      if (Array.isArray(role.permissions) && role.permissions.length === 1 && role.permissions[0] === '*') return true
      return false
    }
  }
}
</script>
<style scoped>
.perm-tags-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  min-height: 32px;
}
</style>
